import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import * as React from 'react';
import { SwitchValue } from '../../../../../../components/CustomFields/Switch';
import { FormReadonly, Section, useWizard } from '../../../../../../design-system';
import type { FormFields, FormValues } from '../../../../../../utils/formUtils';
import { locationField } from '../fields';
import type { Details, LocationWizardStep } from '../types';

type ConfirmationStepProps<T extends FormValues> = { fields: FormFields<T> };

const detailsFields: FormFields<Pick<Details, 'name' | 'referenceId'> & LocationWizardStep> = {
  name: { id: 'name', label: 'Name' },
  location: locationField,
  referenceId: { id: 'referenceId', label: 'Reference ID' },
};

export function ConfirmationStepForm<T extends FormValues>({
  children,
  fields,
}: React.PropsWithChildren<ConfirmationStepProps<T>>) {
  const { state: untypedState, prevStep, nextStep, isLoading } = useWizard();
  const state = untypedState as T & Details;

  return (
    <>
      <Section title="Charge point details">
        <FormReadonly<Details> fields={Object.values({ ...detailsFields, ...fields })} initialValues={state} />
      </Section>
      {children}
      <Section pt={3} title="Configuration">
        <FormReadonly
          fields={[{ id: 'authorizationRequired', label: 'Authorization required', valueComponent: SwitchValue }]}
          initialValues={state}
        />
      </Section>
      <Box pt={2} display="flex">
        <Button color="inherit" disabled={isLoading} onClick={prevStep} variant="contained">
          Back
        </Button>
        <Box mr="auto" />
        <Button color="primary" disabled={isLoading} onClick={nextStep} variant="contained">
          {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Create charge point'}
        </Button>
      </Box>
    </>
  );
}
